
import mapGetActions from '../common/client/sagas/map';

export default function getActions(dispatch) {
    return {
        ...mapGetActions(dispatch),
    };
}
